const tables = [
  {
    name: "Purchase",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
